module.exports = __webpack_public_path__ + "img/all-inkl-banner-oekostrom_320x115.1b68fb0f.webp";